export var NOTIFY_CLICK_MODE;
(function (NOTIFY_CLICK_MODE) {
    NOTIFY_CLICK_MODE["ONLY_NOTIFY"] = "ONLY_NOTIFY";
    NOTIFY_CLICK_MODE["PREVENT_AND_NOTIFY"] = "PREVENT_AND_NOTIFY";
})(NOTIFY_CLICK_MODE || (NOTIFY_CLICK_MODE = {}));
